// import React, { useState, useEffect } from 'react';
// import {
//   AppBar,
//   Toolbar,
//   IconButton,
//   Typography,
//   Box,
//   Avatar,
//   Badge,
//   Menu,
//   MenuItem,
//   CssBaseline,
//   Modal,
//   Paper,
//   CircularProgress,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogContentText,
//   DialogTitle,
//   Button,
// } from '@mui/material';
// import { Notifications as NotificationsIcon } from '@mui/icons-material';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faUserCircle } from '@fortawesome/free-solid-svg-icons';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';

// export default function Navbar({ isSidebarCollapsed, toggleSidebar }) {
//   const [anchorEl, setAnchorEl] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isLogoutDialogOpen, setIsLogoutDialogOpen] = useState(false); // Logout dialog state
//   const [email, setEmail] = useState('');
//   const [notifications, setNotifications] = useState([]);
//   const [loading, setLoading] = useState(true); // Loading state
//   const navigate = useNavigate(); // Navigation hook

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const userEmail = localStorage.getItem('userEmail');
//         if (userEmail) setEmail(userEmail);

//         // Fetch notifications (Replace URL with your API endpoint)
//         const response = await axios.get('/api/notifications'); // Example API
//         setNotifications(response.data.notifications || []);
//       } catch (error) {
//         console.error('Error fetching data:', error);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchData();
//   }, []);

//   // Toggle notification modal
//   const toggleModal = () => {
//     setIsModalOpen(!isModalOpen);
//   };

//   // Handle menu open/close
//   const handleMenuClick = (event) => {
//     setAnchorEl(event.currentTarget);
//   };

//   const handleMenuClose = () => {
//     setAnchorEl(null);
//   };

//   // Open logout confirmation dialog
//   const openLogoutDialog = () => {
//     setIsLogoutDialogOpen(true);
//   };

//   // Close logout confirmation dialog
//   const closeLogoutDialog = () => {
//     setIsLogoutDialogOpen(false);
//   };

//   // Logout logic
//   const handleLogout = () => {
//     // Clear all local storage
//     localStorage.clear();
//     // Navigate to the home page
//     navigate('/');
//   };

//   return (
//     <>
//       <CssBaseline />
//       <AppBar
//         position="fixed"
//         sx={{
//           backgroundColor: '#ffffff',
//           color: '#000000',
//           margin: 0,
//           padding: 0,
//           boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.1)',
//           width: isSidebarCollapsed ? 'calc(100% - 100px)' : 'calc(100% - 300px)',
//           transition: 'width 0.3s ease',
//         }}
//       >
//         <Toolbar
//           sx={{
//             justifyContent: 'space-between',
//             padding: '0 16px',
//             minHeight: '64px',
//           }}
//         >
//           {/* Sidebar Toggle and Title */}
//           <Box sx={{ display: 'flex', alignItems: 'center' }}>
//             <Typography
//               variant="h6"
//               noWrap
//               component="div"
//               sx={{ ml: 2, fontSize: '24px', fontWeight: '600' }}
//             >
//               {loading ? <CircularProgress size={24} /> : 'Dashboard'}
//             </Typography>
//           </Box>

//           {/* Notifications and Profile */}
//           <Box sx={{ display: 'flex', alignItems: 'center' }}>
//             {email && (
//               <Typography sx={{ mr: 2, color: 'gray', fontSize: '14px' }}>
//                 {email}
//               </Typography>
//             )}

//             <IconButton color="inherit" sx={{ mr: 2 }} onClick={toggleModal}>
//               <Badge badgeContent={notifications.length} color="secondary">
//                 <NotificationsIcon />
//               </Badge>
//             </IconButton>

//             <IconButton onClick={handleMenuClick} sx={{ display: 'flex', alignItems: 'center' }}>
//               <Avatar alt="User Profile" sx={{ width: 40, height: 40 }}>
//                 <FontAwesomeIcon icon={faUserCircle} style={{ fontSize: '24px' }} />
//               </Avatar>
//             </IconButton>
//             <Menu
//               anchorEl={anchorEl}
//               open={Boolean(anchorEl)}
//               onClose={handleMenuClose}
//               PaperProps={{
//                 elevation: 3,
//                 sx: { mt: 1 },
//               }}
//             >
//               <MenuItem onClick={handleMenuClose}>Profile</MenuItem>
//               <MenuItem onClick={openLogoutDialog}>Logout</MenuItem>
//             </Menu>
//           </Box>
//         </Toolbar>
//       </AppBar>

//       {/* Notification Modal */}
//       <Modal open={isModalOpen} onClose={toggleModal}>
//         <Paper
//           sx={{
//             position: 'absolute',
//             top: '20%',
//             right: '10%',
//             width: 300,
//             p: 2,
//             boxShadow: 3,
//           }}
//         >
//           <Typography variant="h6" gutterBottom>
//             Notifications
//           </Typography>
//           {loading ? (
//             <CircularProgress size={24} />
//           ) : (
//             <Box>
//               {notifications.length > 0 ? (
//                 notifications.map((notification) => (
//                   <Box
//                     key={notification.id}
//                     sx={{
//                       display: 'flex',
//                       justifyContent: 'space-between',
//                       p: 1,
//                       borderBottom: '1px solid #eee',
//                     }}
//                   >
//                     <Typography variant="body2">{notification.message}</Typography>
//                     <Typography variant="caption" color="textSecondary">
//                       {notification.date}
//                     </Typography>
//                   </Box>
//                 ))
//               ) : (
//                 <Typography variant="body2" color="textSecondary">
//                   No new notifications.
//                 </Typography>
//               )}
//             </Box>
//           )}
//         </Paper>
//       </Modal>

//       {/* Logout Confirmation Dialog */}
//       <Dialog open={isLogoutDialogOpen} onClose={closeLogoutDialog}>
//         <DialogTitle>Logout</DialogTitle>
//         <DialogContent>
//           <DialogContentText>Are you sure you want to logout?</DialogContentText>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={closeLogoutDialog} color="primary">
//             No
//           </Button>
//           <Button onClick={handleLogout} color="primary" autoFocus>
//             Yes
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </>
//   );
// }
// import React, { useState, useEffect } from 'react';
// import {
//   AppBar,
//   Toolbar,
//   IconButton,
//   Typography,
//   Box,
//   Avatar,
//   Badge,
//   Menu,
//   MenuItem,
//   CssBaseline,
//   Modal,
//   Paper,
//   CircularProgress,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogContentText,
//   DialogTitle,
//   Button,
// } from '@mui/material';
// import { Notifications as NotificationsIcon } from '@mui/icons-material';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faUserCircle } from '@fortawesome/free-solid-svg-icons';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';

// export default function Navbar({ isSidebarCollapsed, toggleSidebar }) {
//   const [anchorEl, setAnchorEl] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isLogoutDialogOpen, setIsLogoutDialogOpen] = useState(false); // Logout dialog state
//   const [email, setEmail] = useState('');
//   const [notifications, setNotifications] = useState([]);
//   const [loading, setLoading] = useState(true); // Loading state
//   const navigate = useNavigate(); // Navigation hook

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const userEmail = localStorage.getItem('userEmail');
//         if (userEmail) setEmail(userEmail);

//         // Fetch notifications (Replace URL with your API endpoint)
//         const response = await axios.get('/api/notifications'); // Example API
//         setNotifications(response.data.notifications || []);
//       } catch (error) {
//         console.error('Error fetching data:', error);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchData();
//   }, []);

//   // Toggle notification modal
//   const toggleModal = () => {
//     setIsModalOpen(!isModalOpen);
//   };

//   // Handle menu open/close
//   const handleMenuClick = (event) => {
//     setAnchorEl(event.currentTarget);
//   };

//   const handleMenuClose = () => {
//     setAnchorEl(null);
//   };

//   // Open logout confirmation dialog
//   const openLogoutDialog = () => {
//     setIsLogoutDialogOpen(true);
//   };

//   // Close logout confirmation dialog
//   const closeLogoutDialog = () => {
//     setIsLogoutDialogOpen(false);
//   };

//   // Logout logic
//   const handleLogout = () => {
//     // Clear all local storage
//     localStorage.clear();
//     // Navigate to the home page
//     navigate('/');
//   };

//   return (
//     <>
//       <CssBaseline />
//       <AppBar
//         position="fixed"
//         sx={{
//           backgroundColor: '#ffffff',
//           color: '#000000',
//           margin: 0,
//           padding: 0,
//           boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.1)',
//           width: isSidebarCollapsed ? 'calc(100% - 100px)' : 'calc(100% - 300px)',
//           transition: 'width 0.3s ease',
//         }}
//       >
//         <Toolbar
//           sx={{
//             justifyContent: 'space-between',
//             padding: '0 16px',
//             minHeight: '64px',
//           }}
//         >
//           {/* Sidebar Toggle and Title */}
//           <Box sx={{ display: 'flex', alignItems: 'center' }}>
//             <Typography
//               variant="h6"
//               noWrap
//               component="div"
//               sx={{ ml: 2, fontSize: '24px', fontWeight: '600' }}
//             >
//               {loading ? <CircularProgress size={24} /> : 'Dashboard'}
//             </Typography>
//           </Box>

//           {/* Notifications and Profile */}
//           <Box sx={{ display: 'flex', alignItems: 'center' }}>
//             {email && (
//               <Typography sx={{ mr: 2, color: 'gray', fontSize: '14px' }}>
//                 {email}
//               </Typography>
//             )}

//             <IconButton color="inherit" sx={{ mr: 2 }} onClick={toggleModal}>
//               <Badge badgeContent={notifications.length} color="secondary">
//                 <NotificationsIcon />
//               </Badge>
//             </IconButton>

//             <IconButton onClick={handleMenuClick} sx={{ display: 'flex', alignItems: 'center' }}>
//               <Avatar alt="User Profile" sx={{ width: 40, height: 40 }}>
//                 <FontAwesomeIcon icon={faUserCircle} style={{ fontSize: '24px' }} />
//               </Avatar>
//             </IconButton>
//             <Menu
//               anchorEl={anchorEl}
//               open={Boolean(anchorEl)}
//               onClose={handleMenuClose}
//               PaperProps={{
//                 elevation: 3,
//                 sx: { mt: 1 },
//               }}
//             >
//               <MenuItem onClick={handleMenuClose}>Profile</MenuItem>
//               <MenuItem onClick={openLogoutDialog}>Logout</MenuItem>
//             </Menu>
//           </Box>
//         </Toolbar>
//       </AppBar>

//       {/* Notification Modal */}
//       <Modal open={isModalOpen} onClose={toggleModal}>
//         <Paper
//           sx={{
//             position: 'absolute',
//             top: '20%',
//             right: '10%',
//             width: 300,
//             p: 2,
//             boxShadow: 3,
//           }}
//         >
//           <Typography variant="h6" gutterBottom>
//             Notifications
//           </Typography>
//           {loading ? (
//             <CircularProgress size={24} />
//           ) : (
//             <Box>
//               {notifications.length > 0 ? (
//                 notifications.map((notification) => (
//                   <Box
//                     key={notification.id}
//                     sx={{
//                       display: 'flex',
//                       justifyContent: 'space-between',
//                       p: 1,
//                       borderBottom: '1px solid #eee',
//                     }}
//                   >
//                     <Typography variant="body2">{notification.message}</Typography>
//                     <Typography variant="caption" color="textSecondary">
//                       {notification.date}
//                     </Typography>
//                   </Box>
//                 ))
//               ) : (
//                 <Typography variant="body2" color="textSecondary">
//                   No new notifications.
//                 </Typography>
//               )}
//             </Box>
//           )}
//         </Paper>
//       </Modal>

//       {/* Logout Confirmation Dialog */}
//       <Dialog open={isLogoutDialogOpen} onClose={closeLogoutDialog}>
//         <DialogTitle>Logout</DialogTitle>
//         <DialogContent>
//           <DialogContentText>Are you sure you want to logout?</DialogContentText>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={closeLogoutDialog} color="primary">
//             No
//           </Button>
//           <Button onClick={handleLogout} color="primary" autoFocus>
//             Yes
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </>
//   );
// }

import React, { useState, useEffect } from 'react';
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  Avatar,
  Badge,
  Menu,
  MenuItem,
  CssBaseline,
  Modal,
  Paper,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from '@mui/material';
import { Notifications as NotificationsIcon } from '@mui/icons-material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCircle } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

export default function Navbar({ isSidebarCollapsed, toggleSidebar }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLogoutDialogOpen, setIsLogoutDialogOpen] = useState(false); // Logout dialog state
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true); // Loading state
  const navigate = useNavigate(); // Navigation hook

  // User data from localStorage
  const email = localStorage.getItem('email');
  const username = localStorage.getItem('username');

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch notifications (Replace URL with your API endpoint)
        const response = await axios.get('/api/notifications'); // Example API
        setNotifications(response.data.notifications || []);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // Toggle notification modal
  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  // Handle menu open/close
  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  // Open logout confirmation dialog
  const openLogoutDialog = () => {
    setIsLogoutDialogOpen(true);
  };

  // Close logout confirmation dialog
  const closeLogoutDialog = () => {
    setIsLogoutDialogOpen(false);
  };

  // Logout logic
  const handleLogout = () => {
    // Clear all local storage
    localStorage.clear();
    // Navigate to the home page
    navigate('/Login@elephanttank');
  };

  return (
    <>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          backgroundColor: '#ffffff',
          color: '#000000',
          margin: 0,
          padding: 0,
          boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.1)',
          width: isSidebarCollapsed ? 'calc(100% - 100px)' : 'calc(100% - 300px)',
          transition: 'width 0.3s ease',
        }}
      >
        <Toolbar
          sx={{
            justifyContent: 'space-between',
            padding: '0 16px',
            minHeight: '64px',
          }}
        >
          {/* Sidebar Toggle and Title */}
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{ ml: 2, fontSize: '24px', fontWeight: '600' }}
            >
              {loading ? <CircularProgress size={24} /> : 'Dashboard'}
            </Typography>
          </Box>

          {/* Notifications and Profile */}
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {email && (
              <Typography sx={{ mr: 2, color: 'gray', fontSize: '14px' }}>
                {email}
              </Typography>
            )}

            <IconButton color="inherit" sx={{ mr: 2 }} onClick={toggleModal}>
              <Badge badgeContent={notifications.length} color="secondary">
                <NotificationsIcon />
              </Badge>
            </IconButton>

            <IconButton onClick={handleMenuClick} sx={{ display: 'flex', alignItems: 'center' }}>
              <Avatar alt="User Profile" sx={{ width: 40, height: 40 }}>
                <FontAwesomeIcon icon={faUserCircle} style={{ fontSize: '24px' }} />
              </Avatar>
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
              PaperProps={{
                elevation: 3,
                sx: { mt: 1 },
              }}
            >
              {/* <MenuItem onClick={handleMenuClose}>Profile</MenuItem> */}
              <MenuItem onClick={openLogoutDialog}>Logout</MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Notification Modal */}
      <Modal open={isModalOpen} onClose={toggleModal}>
        <Paper
          sx={{
            position: 'absolute',
            top: '20%',
            right: '10%',
            width: 300,
            p: 2,
            boxShadow: 3,
          }}
        >
          <Typography variant="h6" gutterBottom>
            Notifications
          </Typography>
          {loading ? (
            <CircularProgress size={24} />
          ) : (
            <Box>
              {notifications.length > 0 ? (
                notifications.map((notification) => (
                  <Box
                    key={notification.id}
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      p: 1,
                      borderBottom: '1px solid #eee',
                    }}
                  >
                    <Typography variant="body2">{notification.message}</Typography>
                    <Typography variant="caption" color="textSecondary">
                      {notification.date}
                    </Typography>
                  </Box>
                ))
              ) : (
                <Typography variant="body2" color="textSecondary">
                  No new notifications.
                </Typography>
              )}
            </Box>
          )}
        </Paper>
      </Modal>

      {/* Logout Confirmation Dialog */}
      <Dialog open={isLogoutDialogOpen} onClose={closeLogoutDialog}>
        <DialogTitle>Logout</DialogTitle>
        <DialogContent>
          <DialogContentText>Are you sure you want to logout?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeLogoutDialog} color="primary">
            No
          </Button>
          <Button onClick={handleLogout} color="primary" autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
